<app-header></app-header>
<div class="main no-padding">
  <router-outlet></router-outlet>
</div>